<template>
  <div class="clientContent">
    <div class="clientForm">
      <el-form :rules="rules" ref="clientFormRules" :model="clientInfo" label-position="left">
        <div class="flexStyle mainContent">
          <div class="imgStyle">
            <img :src="clientInfo.headPortraits" v-if="clientInfo.headPortraits" />
            <img :src="pro" alt="" v-else />
          </div>
          <div style="flex: 1">
            <div class="flexStyle">
              <div style="width: 30%">
                <el-form-item label-width="30px">
                  <div class="flexStyleSpan" style="align-item: center">
                    <div style="font-size: 20px; font-weight: 600; color: #444">
                      {{ clientInfo.name }}
                    </div>
                    <div
                      class="operation1"
                      v-if="clientInfo.state && clientInfo.state == '待就业'"
                      style="line-height: 20px"
                    >
                      {{ clientInfo.state }}
                    </div>
                    <div
                      class="operation2"
                      v-if="clientInfo.state && clientInfo.state == '在职'"
                      style="line-height: 20px"
                    >
                      {{ clientInfo.state }}
                    </div>
                    <div
                      class="operation3"
                      v-if="clientInfo.state && clientInfo.state == '已推荐'"
                      style="line-height: 20px"
                    >
                      {{ clientInfo.state }}
                    </div>
                  </div>
                </el-form-item>
                <div class="flexStyle" style="margin-left: 30px">
                  <el-form-item label="性别：" prop="sex" label-width="45px">
                    <p>{{ clientInfo.sex }}</p>
                  </el-form-item>
                  <el-form-item
                    label="年龄："
                    prop="age"
                    label-width="45px"
                    style="margin-left: 25px"
                  >
                    <p>{{ clientInfo.age }}</p>
                  </el-form-item>
                </div>
                <div class="flexStyle" style="margin-left: 30px">
                  <el-form-item label="教育背景：" label-width="70px">
                    <p v-if="clientInfo.educationBackground">
                      {{ clientInfo.educationBackground }}
                    </p>
                    <p v-else>无</p>
                  </el-form-item>
                  <el-form-item label="婚姻状态：" label-width="70px" style="margin-left: 25px">
                    <p v-if="clientInfo.weddingOrNot === 0">已婚</p>
                    <p v-else-if="clientInfo.weddingOrNot === 1">未婚</p>
                    <p v-else-if="clientInfo.weddingOrNot === 2">未知</p>
                  </el-form-item>
                </div>
                <el-form-item label="语言能力：" prop="languageAbility" style="margin-left: 30px">
                  <p v-if="clientInfo.languageAbility !== '/' && clientInfo.languageAbility">
                    {{ clientInfo.languageAbility }}
                  </p>
                  <p v-else>无</p>
                </el-form-item>
                <el-form-item label="工作经验：" prop="workingYears" style="margin-left: 30px">
                  <p>{{ clientInfo.workingYears }}</p>
                </el-form-item>
                <el-form-item label="所属行业：" prop="currentIndustry" style="margin-left: 30px">
                  {{ clientInfo.currentIndustry }}
                </el-form-item>
                <el-form-item label="职位类型：" style="margin-left: 30px">
                  <p>{{ clientInfo.personType }}</p>
                </el-form-item>
              </div>
              <div style="flex: 1">
                <div class="editPush">
                  <span @click="edit"><i class="iconfont icon-jr-icon-modify"></i>编辑</span>
                </div>
                <el-form-item label="联系电话：" prop="phone" style="margin-left: 5%">
                  <div class="flexStyle">
                    <i class="iconfont icon-jr-icon-phone"></i>
                    <p>{{ clientInfo.phone }}</p>
                  </div>
                </el-form-item>
                <el-form-item label="所在地：" label-width="60px" style="margin-left: 5%">
                  <div class="flexStyle">
                    <i class="iconfont icon-jr-icon-address"></i>
                    {{ clientInfo.personCountry }}
                    {{ clientInfo.personProvince }}
                    {{ clientInfo.personCity }}
                  </div>
                </el-form-item>
                <el-form-item label="邮箱：" style="margin-left: 5%">
                  <div class="flexStyle">
                    <i class="iconfont icon-jr-icon-letter"></i>
                    <p>{{ clientInfo.mail }}</p>
                  </div>
                </el-form-item>
                <el-form-item label="微信：" style="margin-left: 5%">
                  <div class="flexStyle">
                    <i class="iconfont icon-jr-icon-wrong"></i>
                    <p>{{ clientInfo.weChat }}</p>
                  </div>
                </el-form-item>
                <el-form-item label="入职时间：" style="margin-left: 5%">
                  <p>
                    {{ clientInfo.entryTime
                    }}<span
                      v-if="clientInfo.timeChoose"
                      style="font-size: 14px; color: #606266; margin-left: 10px"
                      >随时</span
                    ><span v-else style="font-size: 14px; color: #606266; margin-left: 10px"
                      >一个月离职通知</span
                    >
                  </p>
                </el-form-item>
                <el-form-item label="求职渠道：" style="margin-left: 5%">
                  <div class="flexStyle">
                    <p>{{ clientInfo.jobChannels }}</p>
                  </div>
                </el-form-item>
              </div>
            </div>
            <div class="flexStyle">
              <div style="flex: 1">
                <el-form-item label="个人荣誉标签：" label-width="110px" style="margin-left: 30px">
                  <el-tag
                    :key="index + 10"
                    v-for="(tag, index) in clientInfo.listPersonalGlory"
                    :disable-transitions="false"
                    class="tagStyle"
                  >
                    {{ tag }}
                  </el-tag>
                  <el-input
                    class="input-new-tag small_input"
                    v-if="inputVisible"
                    v-model="inputValue"
                    ref="saveTagInput"
                    size="small"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                  >
                  </el-input>
                </el-form-item>
              </div>
            </div>
            <el-form-item label="其他 ：" style="margin-left: 30px">
              <div style="width: 80%">{{ clientInfo.other }}</div>
            </el-form-item>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px" v-show="false">
          <title-bar title="工作经历"></title-bar>
          <div class="personExperienceMessage">
            <el-table
              :data="clientInfo.personDetailsWorkExperiences"
              style="width: 100%"
              border
              :header-cell-style="{ 'text-align': 'center' }"
              :cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column prop="date" label="时间" width="250">
                <template v-slot="{ row }"> {{ row.inductionTime }}~{{ row.quitTime }} </template>
              </el-table-column>
              <el-table-column prop="companyName" label="公司名称" width="250"> </el-table-column>
              <el-table-column prop="position" label="职位"> </el-table-column>
              <el-table-column prop="department" label="所在部门"> </el-table-column>
              <el-table-column prop="reportingObject" label="汇报对象"> </el-table-column>
              <el-table-column prop="date" label="薪资范围" width="250">
                <template v-slot="{ row }">
                  {{ row.salaryExpectation }}~{{ row.salaryExpectationEnd }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <title-bar title="职位期望"></title-bar>
          <div class="expected">
            <i class="iconfont icon-jr-icon-earth"></i>
            <el-form-item label="目前薪资：" label-width="70px">
              <div class="flexStyle" v-if="clientInfo.currentSalaryStart">
                <p v-if="clientInfo.isYears" style="margin-right: 10px">年薪</p>
                <p v-else style="margin-right: 10px">月薪</p>
                <p>{{ clientInfo.currentSalaryStart }}</p>
                <p>~</p>
                <p>{{ clientInfo.currentSalaryEnd }}</p>
              </div>
            </el-form-item>
          </div>
          <div class="contentItem" v-for="(item, index) in expectedPositionLists" :key="index">
            <div class="expected">
              <i class="iconfont icon-jr-icon-address"></i>
              <el-form-item label="期望地点：" label-width="70px">
                {{ item.expectedCountry }}
                {{ item.expectedProvince }}
                {{ item.expectedCity }}
              </el-form-item>
            </div>
            <div class="expected">
              <i class="iconfont icon-jr-icon-collar"></i>
              <el-form-item label="期望职位：" label-width="70px">
                <p>{{ item.expectedPosition }}</p>
              </el-form-item>
            </div>
            <div class="expected">
              <i class="iconfont icon-jr-icon-earth"></i>
              <el-form-item label="期望薪资：" label-width="70px">
                <div class="flexStyle" v-if="clientInfo.salaryExpectation">
                  <p v-if="clientInfo.isAnnual" style="margin-right: 10px">年薪</p>
                  <p v-else style="margin-right: 10px">月薪</p>
                  <p>{{ item.salaryExpectation }}</p>
                  <p>~</p>
                  <p>{{ item.salaryExpectationEnd }}</p>
                </div>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <title-bar title="教育背景"></title-bar>
          <div class="personExperienceMessage">
            <el-table
              :data="clientInfo.personEducational"
              style="width: 100%"
              border
              :header-cell-style="{ 'text-align': 'center' }"
              :cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column prop="date" label="时间" width="250">
                <template v-slot="{ row }"> {{ row.startDate }}~{{ row.endDate }} </template>
              </el-table-column>
              <el-table-column prop="schoolName" label="学校" width="250"> </el-table-column>
              <el-table-column prop="education" label="学历"> </el-table-column>
              <el-table-column prop="major" label="专业"> </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <title-bar title="工作经历及内容"></title-bar>
          <div
            v-show="!personExperienceShow"
            class="personExperienceMessage"
            v-for="(item, index) in clientInfo.personExperience"
            :key="index + 30"
          >
            <div class="personExperienceContent">
              <div class="flexStyleWork">
                <div class="flexStyle">
                  <div style="color: #999999; width: 160px">
                    {{ item.inductionTime }}~<span v-if="item.quitTime">{{ item.quitTime }}</span
                    ><span v-else style="color: #999999">至今</span>
                  </div>
                  <div>
                    <div style="font-size: 18px; font-weight: 600">{{ item.companyName }}</div>
                    <div style="margin: 10px 10px 10px 0; font-size: 15px">
                      担任职位：{{ item.position }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="flexStyle">
                <div style="width: 160px; font-size: 15px; font-weight: 600">职位描述：</div>
                <div style="width: 90%; color: #333333; white-space: pre-line">
                  {{ item.operatingDuty }}
                </div>
              </div>
              <div class="flexStyle" style="margin-top: 20px">
                <div style="width: 160px; font-size: 15px; font-weight: 600">职位业绩：</div>
                <div style="width: 90%; color: #333333; white-space: pre-line">
                  {{ item.jobPerformance }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <title-bar title="部分项目"></title-bar>
          <div
            v-show="!personProjectExperienceShow"
            class="personExperienceMessage"
            v-for="(item, index) in clientInfo.personProjectExperience"
            :key="index + 40"
          >
            <div class="personExperienceContent">
              <div class="flexStyleWork">
                <div class="flexStyle">
                  <div style="color: #999999; width: 160px">
                    {{ item.startTime }}~{{ item.endTime }}
                  </div>
                  <div>
                    <div style="font-size: 18px; font-weight: 600">{{ item.projectName }}</div>
                    <div style="margin: 10px 10px 10px 0; font-size: 15px">
                      担任角色：{{ item.projectFunction }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="flexStyle">
                <div style="width: 160px; font-size: 15px; font-weight: 600">项目描述：</div>
                <div style="width: 90%; color: #333333; white-space: pre-line">
                  {{ item.projectAchievement }}
                </div>
              </div>
              <div class="flexStyle" style="margin-top: 20px">
                <div style="width: 160px; font-size: 15px; font-weight: 600">项目业绩：</div>
                <div style="width: 90%; color: #333333; white-space: pre-line">
                  {{ item.projectPerformance }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <title-bar title="技术能力"></title-bar>
          <div style="margin: 0 0 0 30px">
            <el-tag
              :key="index + 50"
              v-for="(tag, index) in clientInfo.listTechnique"
              :disable-transitions="false"
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="input-new-tag small_input"
              v-if="inputVisibleTech"
              v-model="inputValueTech"
              ref="saveTagInputTech"
              size="small"
            >
            </el-input>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <title-bar title="职业培训"></title-bar>
          <div
            v-show="!vocationalTrainingsShow"
            class="personExperienceMessage"
            v-for="(item, index) in clientInfo.vocationalTrainings"
            :key="index + 60"
          >
            <div class="personExperienceContent">
              <div class="flexStyleWork">
                <div class="flexStyle">
                  <div style="color: #999999; width: 160px">
                    {{ item.startTime }}~{{ item.endTime }}
                  </div>
                  <div>
                    <div style="font-size: 18px; font-weight: 600">{{ item.trainingTopics }}</div>
                    <div style="margin: 10px 10px 10px 0; font-size: 15px">
                      培训地点：{{ item.address }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="flexStyle">
                <div style="width: 160px; font-size: 15px; font-weight: 600">培训内容：</div>
                <div style="width: 90%; color: #333333; white-space: pre-line">
                  {{ item.trainingContent }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <title-bar title="专业认证"></title-bar>
          <div class="personExperienceMessage">
            <el-table
              :data="clientInfo.certifications"
              style="width: 100%"
              border
              :header-cell-style="{ 'text-align': 'center' }"
              :cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column prop="date" label="时间" width="250">
                <template v-slot="{ row }"> {{ row.startTime }}~{{ row.endTime }} </template>
              </el-table-column>
              <el-table-column prop="address" label="地点" width="300"> </el-table-column>
              <el-table-column prop="certificateName" label="专业证书"> </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <title-bar title="业界荣誉"></title-bar>
          <div style="margin: 0 0 0 30px">
            <el-tag
              :key="index + 80"
              v-for="(tag, index) in clientInfo.listHonor"
              :disable-transitions="false"
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="input-new-tag small_input"
              v-if="inputVisibleHonor"
              v-model="inputValueHonor"
              ref="saveTagInputHonor"
              size="small"
            >
            </el-input>
          </div>
        </div>

        <div class="mainContent" style="margin-top: 20px">
          <title-bar title="自我评价"></title-bar>
          <div style="margin: 0px 20px 20px 30px; width: 90%">
            <el-input
              v-model="clientInfo.selfAssessment"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
            ></el-input>
          </div>
        </div>
      </el-form>
      <div class="business_details_foot">
        <p>来源：{{ clientInfo.source }}</p>
        <p>最近更新时间：{{ clientInfo.updateTime }}</p>
      </div>
    </div>
    <div class="buttonStyle">
      <!-- <el-button class="saveButton" @click="save">保存</el-button> -->
      <el-button class="cancelButton" @click="cancel">返回</el-button>
    </div>
    <div class="bottom"></div>
  </div>
</template>

<script>
import pro from '../../../../../static/images/pro.png'
import { insertPerson, updatePerson, getParticularsPersonByid } from '@/api/talent.js'
import TitleBar from '../../../../components/TitleBar.vue'
export default {
  components: {
    TitleBar
  },
  data() {
    return {
      pro,
      options: ['不限', '1年以内', '1~3年', '3~5年', '5~10年', '10年以上'],
      // 个人荣誉标签
      inputVisible: false,
      inputValue: '',
      // 技术能力
      inputVisibleTech: false,
      inputValueTech: '',
      // 业界荣誉
      inputVisibleHonor: false,
      inputValueHonor: '',
      // 工作经历
      personExperienceIndex: null,
      experienceEditIndex: false,
      personExperience: {
        //工作经历
        companyName: '', //公司名称
        position: '', //公司职务
        salaryExpectation: '', //薪资范围
        salaryExpectationEnd: '', //薪资范围
        inductionTime: '', //加入时间
        quitTime: '', //离职时间时间
        operatingDuty: '' //职位描述
      },
      // 工作经历判断条件
      personExperienceShow: false,

      // 项目经历
      personProjectExperience: {
        //项目经历
        startTime: '', //开始时间
        endTime: '', //结束时间
        projectName: '', //项目名称
        projectAchievement: '', //项目内容
        projectFunction: '' //担任角色
      },
      // 项目经理判断条件
      personProjectExperienceShow: false,
      personProjectExperienceIndex: null,
      projectExperienceIndex: false,

      // 职业培训
      vocationalTrainings: {
        //职业培训
        startTime: '', //开始时间
        endTime: '', //结束时间
        trainingTopics: '', //培训主题
        trainingContent: '', //培训内容
        address: '' //培训地点
      },
      // 职业培训判断条件
      vocationalTrainingsShow: false,
      vocationalTrainingsIndex: null,
      vocationalTrainingsIndexBoolean: false,

      // 基本信息
      clientInfo: {
        isAnnual: 0,
        headPortrait: '', //头像
        name: '', //姓名
        sex: '', //性别
        age: '', //年龄
        phone: '', //联系电话
        currentIndustry: '', //所属行业
        workingYears: '', //工作经验
        personType: '', //职位类型
        listPersonalGlory: [], //个人荣誉标签
        other: '', //其他
        state: '', //当前状态
        personCountry: '', //所在国家
        personProvince: '', //所在省份
        personCity: '', //所在城市
        mail: '', //邮箱
        weChat: '', //微信
        personExperience: [],
        expectedCountry: '', //期望国家
        expectedProvince: '', //期望省份
        expectedCity: '', //期望城市
        expectedPosition: '', //期望职位
        salaryExpectation: '', //期望薪资
        salaryExpectationEnd: '', //期望薪资结束
        personEducational: [
          {
            //教育经历
            startDate: '', //开始时间
            endDate: '', //结束时间
            schoolName: '', //学校名称
            education: '', //学历
            major: '' //就读专业
          }
        ],
        personProjectExperience: [],
        listTechnique: [], //我的技能
        vocationalTrainings: [],
        //专业认证
        certifications: [
          {
            startTime: '', //开始时间
            endTime: '', //结束时间
            address: '', //地点
            certificateName: '' //专业证书
          }
        ],
        listHonor: [], //业界荣誉
        selfAssessment: '' //自我评价
      },
      salary: [],
      rules: {},
      expectedPositionList: [], // 期望职位
      salaryExpectationList: [], // 期望薪资 起
      salaryExpectationEndList: [], // 期望薪资 始
      currentSalaryStartList: [], // 目前薪资  起
      currentSalaryEndList: [], // 目前薪资  始
      expectedCountryList: [], // 期望国家
      expectedProvinceList: [], // 期望省份
      expectedCityList: [], // 期望城市
      expectedPositionLists: [] // 循环的数据
    }
  },
  computed: {
    Authorization() {
      return sessionStorage.getItem('token')
    },
    clientType() {
      return this.$route.query.clientType
    },
    clientId() {
      return this.$route.query.id
    },
    tabName() {
      return this.$route.query.tabName
    },
    projectId() {
      return Number(this.$route.query.projectId)
    },
    projectPositionType() {
      return this.$route.query.positionType
    },
    chidrenQueryInfo() {
      // return JSON.parse(this.$route.query.chidrenQueryInfo)
      if (this.$route.query.chidrenQueryInfo) {
        return JSON.parse(this.$route.query.chidrenQueryInfo)
      } else {
        return null
      }
    },
    searchInfo() {
      if (this.$route.query.searchInfo) {
        return JSON.parse(this.$route.query.searchInfo)
      } else {
        return null
      }
    }
  },
  created() {
    this.$store.commit('changeQueryInfo', this.searchInfo)
    switch (this.tabName) {
      case 'first':
        this.$store.commit('projectCenter/changeMatchQueryInfo', this.chidrenQueryInfo)
        break

      case 'second':
        this.$store.commit('projectCenter/changeAllSearchQueryInfo', this.chidrenQueryInfo)
        break

      case 'third':
        this.$store.commit('projectCenter/changeCommunicateQueryInfo', this.chidrenQueryInfo)
        break

      default:
        break
    }
    this.routerTo()
    if (this.clientType) {
      console.log(111)
      this.getpositionListByid()
    }
  },
  methods: {
    routerTo() {
      document.body.scrollTop = 0
    },
    // 单个查询
    async getpositionListByid() {
      const res = await getParticularsPersonByid({ PreCode: this.clientId })
      if (res.data.resultCode == 200) {
        this.clientInfo = res.data.data
        this.expectedPositionList = res.data.data.expectedPosition.split(',') // 期望职位
        this.salaryExpectationList = res.data.data.salaryExpectation.split(',') // 期望薪资 起
        this.salaryExpectationEndList = res.data.data.salaryExpectationEnd.split(',') // 期望薪资 始
        if (res.data.data.expectedCountry == null) {
          this.expectedCountryList = []
        } else {
          this.expectedCountryList = res.data.data.expectedCountry.split(',') // 期望国家
        }
        if (res.data.data.expectedProvince == null) {
          this.expectedProvinceList = []
        } else {
          this.expectedProvinceList = res.data.data.expectedProvince.split(',') // 期望省份
        }

        if (res.data.data.expectedCity == null) {
          this.expectedCityList = []
        } else {
          this.expectedCityList = res.data.data.expectedCity.split(',') // 期望城市
        }

        // this.expectedProvinceList = res.data.data.expectedProvince.split(',') // 期望省份
        // this.expectedCityList = res.data.data.expectedCity.split(',') // 期望城市

        if (res.data.data.currentSalaryStart.includes(',')) {
          this.currentSalaryStartList[0] = res.data.data.currentSalaryStart
        }
        if (res.data.data.salaryExpectationEnd.includes(',')) {
          this.currentSalaryEndList[0] = res.data.data.currentSalaryEnd
        }

        // console.log(this.expectedPositionList)
        // console.log(this.salaryExpectationList)
        // console.log(this.salaryExpectationEndList)
        this.expectedPositionList.forEach((item, index) => {
          this.expectedPositionLists.push({
            expectedPosition: this.expectedPositionList[index], // 期望职位
            salaryExpectation: this.salaryExpectationList[index], // 期望薪资 起
            salaryExpectationEnd: this.salaryExpectationEndList[index], // 期望薪资 始
            expectedCountry: this.expectedCountryList[index], // 期望国家
            expectedProvince: this.expectedProvinceList[index], // 期望省份
            expectedCity: this.expectedCityList[index] // 期望城市
          })
        })
        // console.log(this.expectedPositionLists)
        // console.log(this.currentSalaryStartList)
        // console.log(this.currentSalaryEndList)
        console.log(this.expectedPositionLists)
        if (this.clientInfo.salaryRange) {
          this.salary = this.clientInfo.salaryRange.split('~')
        }
      }
    },
    //   添加联系人
    addprojectLeaderListAdd() {
      this.clientInfo.projectLeaderListAdd.push({
        contactInformation: '', //微信号
        projectLeader: '', //联系人姓名
        targetEnterprise: ''
      })
    },
    // 国家地区
    searchArae(val) {
      this.clientInfo.personCountry = val.country

      this.clientInfo.personProvince = val.province

      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.clientInfo.personCity = val.city
      }
    },
    // 期望国家地区
    searchAraeExpected(val) {
      this.clientInfo.expectedCountry = val.country

      this.clientInfo.expectedProvince = val.province

      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.clientInfo.expectedCity = val.city
      }
    },
    //   删除联系人
    removeprojectLeaderListAdd(index) {
      this.clientInfo.projectLeaderListAdd.splice(index, 1)
    },
    // 保存
    save() {
      this.$refs.clientFormRules.validate(async (valid) => {
        if (valid) {
          if (this.salary.length > 0) {
            this.clientInfo.salaryRange = this.salary.join('~')
          }
          // if (this.clientInfo.age) {
          //   this.clientInfo.age = Number(this.clientInfo.age)
          // }
          let res
          if (this.clientType) {
            res = await updatePerson(this.clientInfo)
          } else {
            res = await insertPerson(this.clientInfo)
          }
          if (res.data.resultCode === 200) {
            if (this.clientType) {
              this.$message.success('修改成功')
            } else {
              this.$message.success('新增成功')
            }
            this.cancel()
          }
        }
      })
    },
    // 返回
    cancel() {
      if (this.tabName) {
        this.$router.push({
          name: 'Candidate',
          query: {
            tabName: this.tabName,
            id: this.projectId,
            positionType: this.projectPositionType,
            chidrenQueryInfo: JSON.stringify(this.chidrenQueryInfo),
            searchInfo: JSON.stringify(this.searchInfo)
          }
        })
      } else {
        this.$router.go(-1)
      }
    },

    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.clientInfo.listPersonalGlory.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    edit() {
      this.$router.push({
        name: 'TalentMessage',
        query: {
          id: this.clientInfo.personCode,
          clientType: 1
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.mainContent {
  background-color: #fff;
  padding: 20px;
  width: 100%;
  height: 100%;
  overflow: auto;

  .expected {
    display: flex;
    align-items: center;
    margin-left: 30px;

    /deep/ .el-form-item {
      margin-bottom: 0;
    }
  }

  .contentItem {
    margin-top: 20px;
  }
}

.flexStyle {
  display: flex;
}

.flexStyleCloum {
  display: flex;
  flex-direction: column;
}

.inputStyle {
  /deep/ .el-input {
    margin: 0 5px 5px 0;
  }

  .iconStyle {
    display: inline-block;
    height: 100%;
    font-size: 28px;
    vertical-align: middle;
    cursor: pointer;
    color: #17757a;
  }
}

.buttonStyle {
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 100%;
  background-color: #fff;
  padding: 0 10px 20px 10px;
  width: 100%;
}

/deep/ .saveButton {
  background-color: #17757a !important;
  color: #fff !important;
  padding: 10px 30px;
  border: 1px solid #17757a;
}

/deep/ .cancelButton {
  border-color: #17757a !important;
  color: #17757a;
  padding: 10px 30px;
}

/deep/ .el-button:focus,
.el-button:hover {
  background-color: #fff;
}

.bottom {
  height: 20px;
}

.spanStyle {
  display: inline-block;
  padding: 0 10px;
  color: #17757a;
}

.dropDownBox {
  /deep/ .el-input__inner {
    width: 100%;
  }

  /deep/ .el-select {
    width: 100%;
  }
}

.formStyle {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  /deep/ .el-form-item__label {
    display: block;
    width: 100% !important;
    text-align: left;
    color: #17757a;
    font-size: 15px;
    font-weight: 600;
  }
}

.imgStyle {
  text-align: center;

  /deep/ .el-button {
    padding: 5px 10px;
    border-color: #17757a;
    color: #17757a;
  }
}

i {
  color: #17757a;
  font-size: 18px;
  margin-right: 5px !important;
  display: inline-block;
}

/deep/ .el-tag .el-tag__close {
  color: #17757a;
}

/deep/ .el-tag .el-tag__close:hover {
  color: #fff;
}

/deep/ .el-button:focus,
.el-button:hover {
  border-color: #17757a;
  color: #17757a;
}

/deep/ .el-form-item__label {
  padding: 0;
}

.personEducational {
  padding: 0 0 20px 30px;
}

.personEducationalDiv {
  display: inline-block;
  margin-left: 20px;
  cursor: pointer;
}

i {
  font-size: 20px;
  margin-right: 0;
  vertical-align: bottom;
}

span {
  color: #17757a;
  font-size: 16px;
  display: inline-block;
}

.flexStyleBottom {
  display: flex;
  justify-content: space-between;

  .personEducationalDiv {
    margin-right: 10%;
  }

  span {
    display: inline-block;
    vertical-align: bottom;
    line-height: 23px;
  }
}

.editPush {
  height: 40px;
  text-align: right;
  padding-right: 100px;
  line-height: 40px;

  span {
    cursor: pointer;
  }
}

// 工作经历
.personExperience {
  height: 100%;
  width: 100%;
  transition: all 0.2s ease;
  box-sizing: border-box;
  padding: 0 20px 20px 20px;

  .personExperienceContent {
    background-color: #fafdfb;
    padding: 20px;
    border-radius: 5px;
    border: 1px solid #e6e6e6;
  }

  .personExperienceFlex {
    display: flex;
  }

  .buttonPersonExperience {
    text-align: right;
    padding: 20px 20px 0 20px;

    .successButtonPersonExperience {
      background-color: #17757a;
      color: #fff;
      border: 1px solid #17757a;
    }
  }
}

// 工作经历详情
.personExperienceMessage {
  // background-color: yellow;/
  width: 90%;
  padding: 0 20px 20px 30px;

  .personExperienceContent {
    border: 1px solid #e6e6e6;
    border-radius: 5px;
    padding: 20px;
  }

  .flexStyleWork {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  span {
    display: inline-block;
    margin-right: 20px;
    cursor: pointer;

    .icon-jr-icon-delete {
      color: #fa5050;
    }
  }
}

.clientContent {
  height: 100%;
}

img {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}

/deep/ .el-tag {
  font-size: 12px !important;
}

/deep/ .el-form-item {
  margin-bottom: 0;
  color: #606266;
}

.el-table {
  border: 1px solid #e6e6e6;
}

.flexStyleSpan {
  display: flex;
  align-items: center;
}

.business_details_foot {
  width: 100%;
  overflow: hidden;
  background-color: #fff;
  padding-left: 40px;

  p {
    color: #999999;
    font-size: 12px;
    margin-top: 4px;
    line-height: 1.5em;
  }
}
</style>
